import { firebaseApp } from "../firebase/init-firebase"
import { getAuth, signInWithEmailAndPassword, setPersistence, browserLocalPersistence, signOut } from "firebase/auth"
import { doc, getFirestore, getDoc } from "firebase/firestore"

import config from "../config"

const db = getFirestore()

const auth = getAuth(firebaseApp)

export const signInUser = async (payload) => {
    const email = payload.email
    const password = payload.password

    await setPersistence(auth, browserLocalPersistence)
    return signInWithEmailAndPassword(auth, email, password)
}

export const signOutUser = () => {
    return signOut(auth)
}

export const getUserById = (userId) => {
    return getDoc(doc(db, config.COLLECTIONS.USERS, userId))
}

export const getAddressById = (addressId) => {
    return getDoc(doc(db, config.COLLECTIONS.ADDRESSES, addressId))
}
